import { circle, type Circle } from '../geom';
import type { CircleNode } from '../model';
import { evaluatePoint, pointFields, pointValues } from './parts';
import type { EntityDefinition } from './types';

export const CIRCLE: EntityDefinition<CircleNode, Circle> = {
  type: 'circle',
  label: 'Circle',
  fields: [...pointFields('center', 'Center'), { path: 'radius', label: 'Radius', unit: 'length' }],
  resolve: (node, evaluate) => circle(evaluatePoint(node.center, evaluate), evaluate(node.radius)),
  fromShape: (c) => ({ ...pointValues('center', c.center), radius: c.radius }),
};
